import { collection, doc, setDoc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from './firebase';
import catalogoProductos from '../data/catalogo-productos.json';

// Cargar el catálogo global de productos (solo se hace una vez)
export const cargarCatalogoGlobal = async () => {
  try {
    const catalogoRef = collection(db, 'catalogo_productos');
    
    // Verificar si ya existe el catálogo
    const snapshot = await getDocs(catalogoRef);
    if (snapshot.size > 0) {
      console.log('El catálogo ya existe');
      return;
    }
    
    // Cargar productos del JSON
    console.log('Cargando catálogo de productos...');
    const productos = catalogoProductos.medicamentos || catalogoProductos.productos || [];
    
    for (const producto of productos) {
      await setDoc(doc(catalogoRef, producto.codigoBarras), {
        ...producto,
        stock: 0, // Siempre empieza sin stock
        fechaCarga: new Date().toISOString()
      });
    }
    
    console.log(`${productos.length} productos cargados al catálogo`);
  } catch (error) {
    console.error('Error cargando catálogo:', error);
  }
};

// Buscar producto en el catálogo global por código de barras
export const buscarProductoEnCatalogo = async (codigoBarras) => {
  try {
    const productoDoc = await getDoc(doc(db, 'catalogo_productos', codigoBarras));
    
    if (productoDoc.exists()) {
      return productoDoc.data();
    }
    
    return null;
  } catch (error) {
    console.error('Error buscando producto en catálogo:', error);
    return null;
  }
};

// Buscar productos por sustancia (categoría)
export const buscarPorSustancia = async (sustancia) => {
  try {
    const q = query(
      collection(db, 'catalogo_productos'),
      where('sustancia', '==', sustancia.toUpperCase())
    );
    
    const snapshot = await getDocs(q);
    const productos = [];
    
    snapshot.forEach((doc) => {
      productos.push({ id: doc.id, ...doc.data() });
    });
    
    return productos;
  } catch (error) {
    console.error('Error buscando por sustancia:', error);
    return [];
  }
};

// Buscar productos por texto
export const buscarProductosEnCatalogo = async (textoBusqueda) => {
  try {
    // Firestore no soporta búsqueda de texto completo nativamente
    // Por ahora, obtenemos todos y filtramos en cliente
    const snapshot = await getDocs(collection(db, 'catalogo_productos'));
    const productos = [];
    const texto = textoBusqueda.toLowerCase();
    
    snapshot.forEach((doc) => {
      const producto = doc.data();
      if (producto.busqueda && producto.busqueda.toLowerCase().includes(texto)) {
        productos.push({ id: doc.id, ...producto });
      }
    });
    
    return productos;
  } catch (error) {
    console.error('Error buscando productos:', error);
    return [];
  }
};

// Obtener todas las sustancias (categorías) disponibles
export const obtenerSustancias = async () => {
  try {
    const snapshot = await getDocs(collection(db, 'catalogo_productos'));
    const sustancias = new Set();
    
    snapshot.forEach((doc) => {
      const producto = doc.data();
      if (producto.sustancia) {
        sustancias.add(producto.sustancia);
      }
    });
    
    return Array.from(sustancias).sort();
  } catch (error) {
    console.error('Error obteniendo sustancias:', error);
    return [];
  }
};